define.alias("shared/utils/object-methods/object-snake-to-camel", "settings/utils/object-methods/object-snake-to-camel");